import $ from 'jquery';

/**
 * Add in hover effects for media links
 *
 * @param context
 */
export default function mediaLinkHover(context=document.body) {
    const $context = $(context);

    $context.find('[sw-media-col-hover]').each(function() {
        const $a = $(this);
        
        $a.hover(function(){
            $a.parent().parent().addClass('media-hover');
        }, function() {
            $a.parent().parent().removeClass('media-hover');
            $a.parent().parent().addClass('media-hover-out');

            setTimeout(function(){
                $a.parent().parent().removeClass('media-hover-out');
            }, 800);
        });
    });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/media/media-link-hover.js